import type { FetchError } from "common/types/fetchError";
import httpErrorMessage from "common/utils/httpErrorMessage";
import Button from "ui/buttons/Button";
import IconInfoLine from "ui/icons/IconInfoLine";
import Tooltip from "ui/popovers/Tooltip";
import styles from "./FetchErrorMessage.module.scss";

interface FetchErrorMessageProps {
  fetchError: FetchError | null;
  onRetry?: () => void;
}

export function FetchErrorMessage({ fetchError, onRetry }: FetchErrorMessageProps) {
  if (!fetchError) {
    return null;
  }

  const { message } = httpErrorMessage(fetchError.status ?? 500);

  return (
    <div className={styles.errorBody}>
      <div className={styles.errorText}>
        <Tooltip.Root>
          <Tooltip.Trigger>
            <span>
              <IconInfoLine size={22} />
            </span>
          </Tooltip.Trigger>
          <Tooltip.Content>{message}</Tooltip.Content>
        </Tooltip.Root>
        Error
      </div>
      {onRetry && (
        <Button btnStyle="tertiary" btnSize="small" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  );
}
